export default __webpack_public_path__ + "static/media/rightArrowActive.61eaeaab.svg";